/**
 * Shared contract for the bulk-delete endpoints.
 * Mirrors CCMSLib.Models.Common.BulkDeleteRequest / BulkDeleteResultView.
 */
/** Fallback for a response with no body, so callers never have to null-check the counts. */
export const EMPTY_BULK_DELETE_RESULT = {
    requested: 0,
    deleted: 0,
    deletedIds: [],
    notFoundIds: [],
};
//# sourceMappingURL=BulkDelete.js.map